import { Alert, Button, Grid, TextField } from "@mui/material";
import { ValidateDataUser } from "../../../hooks/resetPassword";
import { useLoading } from "../../../components/Loading/useLoading";
import { useState } from "react";
import { useSnackbar } from "notistack";

export const DataValidate = ({nextStep, expiredPass}) => {
  const { validateDataUserMutation } = ValidateDataUser();
  const { setAppLoading } = useLoading();
  const { enqueueSnackbar } = useSnackbar();
  const [userRfc, setUserRfc] = useState(null);
  const [username, setUsername] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [userEmployeeNumber, setUserEmployeeNumber] = useState(null);

  const validateForm = () => {
    if (
      username === "" ||
      userRfc === "" ||
      userEmployeeNumber === "" ||
      !username ||
      !userRfc ||
      !userEmployeeNumber
    ) {
      return false;
    }
    return true;
  };

  const sendValidateData = (body) => {
    setAppLoading(true);
    validateDataUserMutation(body, {
      onSuccess: (data) => {
        console.log(data);
        if (!data) {
          enqueueSnackbar(
            "La información no coincide con los registros del usuario, favor de verificar",
            {
              autoHideDuration: 2000,
              variant: "error",
              anchorOrigin: {
                vertical: "top",
                horizontal: "center",
              },
            },
          );
        }else{
          nextStep(username)
        }
      },
      onError: (error) => {
        enqueueSnackbar("No se pudo validar la información", {
          autoHideDuration: 2000,
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onSettled: () => {
        setAppLoading(false);
      },
    });
  };

  const handleValidate = () => {
    if (validateForm()) {
      const payload = {
        username,
        userRfc,
        userEmployeeNumber,
      };
      sendValidateData(payload);
    } else {
      setShowAlert(true);
    }
  };

  return (
    <Grid container spacing={0}>
      <Grid item xs={12} sx={{ p: 0, mb: 0, pr: 1 }} className="center_item">
        <p style={{ textAlign: "justify" }}>
          {expiredPass ? 
          'Por seguridad el sistema despúes de un lapso de tiempo asignado por el administrador se requiere que se actualice su contraseña' : 
          'Para poder recuperar su contraseña primero debemos verificar su identidad con los datos almacenados en el sistema' 
          }
        </p>
      </Grid>
      <Grid item xs={12} sx={{ p: 0, mb: 2, pr: 1 }} className="center_item">
        <p style={{ textAlign: "justify" }}>
          Por favor ingrese los siguientes datos para continuar
        </p>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          p: 0,
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "column",
          mb: 2,
        }}
      >
        <TextField
          id="username"
          name="username"
          label="Username"
          size="small"
          fullWidth
          onChange={(e) => setUsername(e.target.value)}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          p: 0,
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "column",
          mb: 2,
        }}
      >
        <TextField
          id="user_rfc"
          name="user_rfc"
          label="CURP"
          size="small"
          fullWidth
          inputProps={{
            maxLength: 18,
          }}
          onChange={(e) => setUserRfc(e.target.value)}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          p: 0,
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <TextField
          id="user_employee_number"
          name="user_employee_number"
          label="N° Empleado"
          size="small"
          fullWidth
          inputProps={{
            maxLength: 50,
          }}
          onChange={(e) => setUserEmployeeNumber(e.target.value)}
        />
      </Grid>
      {showAlert && (
        <Grid
          item
          xs={12}
          sx={{
            p: 0,
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
          }}
        >
          <Alert
            severity="warning"
            variant="outlined"
            sx={{
              width: "100%",
              mb: 1,
              p: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Los datos no son correctos, favor de verificar
          </Alert>
        </Grid>
      )}
      <Grid
        item
        xs={12}
        sx={{
          p: 0,
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "column",
          mt: 3,
        }}
      >
        <Button
          variant="contained"
          className="btn_lg"
          type="button"
          onClick={handleValidate}
        >
          Validar
        </Button>
      </Grid>
    </Grid>
  );
};
